export default function CardSubtitle({ text }: { text: string }) {
    return (
        <p className="text-xs">{text}</p>
    )
}